/**
 * Client-side view of the CMS feature flags.
 *
 * The server renders `appSettings` into the page as the global `settings`
 * (see `layout.server.view.html`), so what the client sees is what
 * `config.featureFlags` says, with no extra request.
 */

/**
 * Are blog categories switched on?
 *
 * Mirrors `config.featureFlags.blogCategories`. While off, the server omits
 * categories from every public payload and 404s the admin category API, so
 * this only decides what the UI offers; it is not a security boundary.
 *
 * @returns {Boolean}
 */
export function isBlogCategoriesEnabled() {
  return Boolean(
    typeof window !== 'undefined' &&
      window.settings &&
      window.settings.blogCategoriesEnabled,
  );
}
